export default "__VITE_ASSET__BGfVQpfZ__"